import { Box, Stack, styled, Input } from '@ltvco/refresh-lib/theme';

export const StyledAccountPageContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  padding: theme.spacing(2.5),
}));

export const StyledDarkenedStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.spacing(1),
}));

export const StyledInitials = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.background.paper,
  borderRadius: '50%',
  width: theme.spacing(5),
  height: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledInput = styled(Input)({
  width: '100%',
});
